import { render, staticRenderFns } from "./UserInvoice.vue?vue&type=template&id=2265ff56&scoped=true&"
import script from "./UserInvoice.vue?vue&type=script&lang=ts&"
export * from "./UserInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./UserInvoice.vue?vue&type=style&index=0&id=2265ff56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265ff56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
